export default class Column {
  title: string;
  attribute: string;
  path: string;
  classNames?: string;
  renderer?: (item: any) => any;
  sortable?: boolean;
  attributeType?: AttributeType;
  filterPlaceholder?: string;
  filterMinimumLength?: number;
}

export interface Enum {
  values: { [key: string]: string };
}

export enum AttributeType {
  PHONE_NUMBER = "PHONE_NUMBER",
  STRING = "STRING",
  DATE = "DATE",
  BOOLEAN = "BOOLEAN",
  ENUM = "ENUM",
  STRING_ARRAY = "STRING_ARRAY",
  UUID_ARRAY = "UUID_ARRAY",
  UNFILTERABLE = "UNFILTERABLE",
}
